<template>
  <div><div class="thank-you-container" v-html="message"></div></div>

</template>
<script setup lang="ts">
defineProps<{
  message?: string
}>()
</script>
<style scoped>
.thank-you-container {
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    color: #3c763d;
    background-color: #dff0d8;
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    border-radius: 4px;
    border-color: #d6e9c6;
}
</style>
